import React from 'react';
import { DndContext } from '@aha-app/react-dnd-backend';
import { DndProvider } from 'react-dnd';

const SharedDndProvider = props => {
  return (
    <DndProvider
      backend={DndContext.dragDropManager.backend}
      manager={DndContext.dragDropManager}
    >
      {props.children}
    </DndProvider>
  );
};

export default SharedDndProvider;
